import { Colors, Styles } from "../preset.constants";

export const toggleswitchPreset = {
    background: Colors.PrimaryBackground,
    shadow: Styles.BoxShadowSM,
    checked: {
        background: Colors.PrimaryBackground
    },
    handle: {
        checked: {
            background: Colors.SuccessColor
        }
    }
}